import { useState, type FormEvent } from "react";

export function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const res = await fetch("/api/v1/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message, website: honeypot }),
      });
      if (!res.ok && res.status !== 204) {
        const text = await res.text();
        throw new Error(text || res.statusText);
      }
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to send");
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 560 }}>
        <h1>Contact</h1>
        <p style={{ color: "var(--muted)" }}>
          Send the operator a message. We reply to the email you give us — that's it,
          no list, no follow-up automation.
        </p>
        {submitted && (
          <div className="alert alert-success">Thanks — we'll be in touch.</div>
        )}
        {error && <div className="alert alert-error">{error}</div>}
        {!submitted && (
          <form onSubmit={handleSubmit}>
            {/* Honeypot field — keep it visually hidden, real users leave empty. */}
            <input
              type="text"
              name="website"
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
              autoComplete="off"
              tabIndex={-1}
              style={{ position: "absolute", left: "-10000px", width: 1, height: 1 }}
              aria-hidden="true"
            />
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input id="name" type="text" required value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" rows={5} required value={message} onChange={(e) => setMessage(e.target.value)} />
            </div>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <a href="/" style={{ padding: "0.625rem 1rem", borderRadius: 8, border: "1px solid var(--border)", textDecoration: "none" }}>Back</a>
              <button type="submit" className="btn-primary">Send</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
